module.exports = __webpack_public_path__ + "img/map.42c31826.png";